export const waitMs = (ms: number) =>
  new Promise<void>((res) => setTimeout(res, ms));
